import React from 'react';
import { Brand } from '../icons/BrandLogo';

export const PageHeader = ({
  navSlot,
  actionsSlot,
}: {
  navSlot?: React.ReactNode;
  actionsSlot: React.ReactNode;
}) => (
  <header className="sticky top-0 z-100 flex items-center justify-between border-b border-brand-teal/12 bg-brand-bg/80 px-8 py-4 backdrop-blur-xl">
    <div className="flex items-center gap-3">
      <Brand size="sm" />
      {navSlot}
    </div>
    <div className="flex items-center gap-3.5">{actionsSlot}</div>
  </header>
);

export const HeroSection = ({
  badge,
  title,
  gradientTitle,
  description,
  className = '',
}: {
  badge: string;
  title: string;
  gradientTitle: string;
  description: string;
  className?: string;
}) => (
  <div className={`text-center ${className}`}>
    <div className="mb-5 inline-flex animate-badge-in items-center gap-2 rounded-full border border-brand-teal/25 bg-brand-teal/8 px-3.5 py-1.5 text-[0.7rem] font-bold tracking-[0.12em] text-brand-teal">
      <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-brand-teal" />
      {badge}
    </div>
    <h1 className="m-0 mb-3 animate-title-in text-[clamp(2rem,5vw,3.5rem)] font-extrabold tracking-[-0.03em] text-white">
      {title}
      <span className="bg-linear-to-br from-brand-teal to-brand-blue bg-clip-text text-transparent"> {gradientTitle}</span>
    </h1>
    <p className="m-0 animate-title-in text-base text-white/40">{description}</p>
  </div>
);

export const PageFooter = () => (
  <footer className="mt-16 flex items-center justify-center gap-2.5 text-[0.78rem] text-white/18">
    <a
      href="https://techfusion.pt"
      target="_blank"
      rel="noopener noreferrer"
      className="text-brand-teal/40 no-underline transition-colors duration-200 hover:text-brand-teal"
    >
      techfusion.pt
    </a>
  </footer>
);

export const PageShell = ({ children }: { children: React.ReactNode }) => (
  <div className="relative min-h-screen w-full overflow-x-hidden bg-brand-bg font-sans text-white">{children}</div>
);

export const PageMain = ({ children }: { children: React.ReactNode }) => (
  <main className="relative z-2 mx-auto max-w-[1280px] px-8 pt-12 pb-16">{children}</main>
);

export const LoadingState = ({ label }: { label: string }) => (
  <div className="col-span-full flex flex-col items-center gap-4 p-16 text-sm text-white/35">
    <span className="inline-block h-10 w-10 animate-spin-fast rounded-full border-2 border-brand-teal/15" style={{ borderTopColor: '#46c0ba' }} />
    <span>{label}</span>
  </div>
);
